import getuser from "../../actions/getuser";
import axios from "axios";

export async function GetProfileService(_id, dispatch) {
  let msg = "Invalid Crediationals";
  const headers = {
    "Content-Type": "application/json",
  };
  const res = await axios.get(
    `${process.env.REACT_APP_API_ENDPOINT}/getprofile?_id=${_id}`,
    { headers }
  );
  console.log(res);
  if (res.error) {
    console.log(res.data);
    msg = "Some Error occurred.";
  } else {
    dispatch(getuser(res.data));
    msg = "Success";
  }
  return msg;
}
